import React from 'react'
import {KTIcon} from "../../../../_metronic/helpers";
import {useDeleteModal} from "../../../context/DeleteModalContext";
import {MODERATOR_NOTIFICATION} from "../../../mock/URLs";
import {INotificationItem} from "../../../types/notification";
import moment from "moment";
import imgBaseUrl from "../../../utils/imgBaseUrl";
import {PLACEHOLDER_IMAGE_URL} from "../../../mock/constants";

type NotificationCardProps = {
  refetchNotification: () => void,
  notificationItem: INotificationItem
}

export const NotificationCard = ({refetchNotification, notificationItem}: NotificationCardProps) => {
  const {openDeleteModal} = useDeleteModal()

  const handleDeleteClick = (id: number) => {
    openDeleteModal(MODERATOR_NOTIFICATION, id, refetchNotification);
  };

  return (
      <div className={"mb-5"}>
        <div className="card">
          <div className={"p-5 rounded-4 row"}>
            <div className={"col-md-10"}>
              <div className={"d-flex gap-3"}>
                {notificationItem?.banner ?
                    <img className={"rounded-4 h-100px w-100px object-fit-cover"} alt={notificationItem?.title} src={imgBaseUrl(notificationItem?.banner!)}/> :
                    <img className={"rounded-4 h-100px w-100px object-fit-cover"} alt={notificationItem?.title} src={PLACEHOLDER_IMAGE_URL}/>}
                <div>
                  <h1 className={"fs-2"}>{notificationItem?.title}</h1>
                  <p className={"text-muted"}>
                    {notificationItem?.message}
                  </p>
                  <p className="text-muted mb-0 fs-7">{moment(notificationItem?.created_at).format("DD.MM.YYYY HH:mm:ssss")}</p>
                </div>
              </div>
            </div>
            <div className={"col-md-2"}>
              <button onClick={() => handleDeleteClick(notificationItem?.id)}
                      className="btn btn-danger btn-sm w-100 mt-2">
                <KTIcon iconName={"trash-square"} className={"fs-3"}/>
                O'chirish
              </button>
            </div>
          </div>
        </div>
      </div>
  )
}
